(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer-signoff"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const yearSpan = document.querySelector('.year');
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-only-tesimonials"] && !Shopify.designMode) return;
  try {
    
  const testimonialSections = document.querySelectorAll('.testimonials');
  testimonialSections.forEach(section => {
  const slides = section.querySelectorAll('.review-slide');
  const nextButtons = section.querySelectorAll('.carousel-next');
  const prevButtons = section.querySelectorAll('.carousel-prev');
  let index = 0;

  function showSlide(i) {
    slides.forEach(slide => slide.classList.remove('active'));
    slides[i].classList.add('active');
  }

  nextButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      showSlide(index);
    });
  });

  prevButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      showSlide(index);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
const testimonialSections = document.querySelectorAll('.testimonials');
testimonialSections.forEach(section => {
const slides = section.querySelectorAll('.review-slide');
const nextButtons = section.querySelectorAll('.carousel-next');
const prevButtons = section.querySelectorAll('.carousel-prev');
let index = 0;

function showSlide(i) {
  slides.forEach(slide => slide.classList.remove('active'));
  slides[i].classList.add('active');
}

nextButtons.forEach(btn => {
  btn.addEventListener('click', () => {
    index = (index + 1) % slides.length;
    showSlide(index);
  });
});

prevButtons.forEach(btn => {
  btn.addEventListener('click', () => {
    index = (index - 1 + slides.length) % slides.length;
    showSlide(index);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
